import {
  LOADER,
  MODAL_LOADER,
  SAVE_FEEDBACK_SUCCESS,
  SAVE_FEEDBACK_FAILED,
  CLEAR_STATE,
  SUCCESS,
  ERROR,
} from "../actions/types";

const initialState = {
  loader: false,
  modalLoader: false,
  saveFeedbackMsg: "",
  saveFeedbackErrMsg: "",
  successMsg: "",
  errorMsg: "",
};

const HeaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER:
      return { ...state, loader: action.payload };

    case MODAL_LOADER:
      return { ...state, modalLoader: action.payload };
    case SUCCESS:
      return { ...state, successMsg: action.payload };
    case ERROR:
      return { ...state, errorMsg: action.payload };
    case SAVE_FEEDBACK_SUCCESS:
      return {
        ...state,
        loader: false,
        saveFeedbackMsg: action.response.Message,
      };

    case SAVE_FEEDBACK_FAILED:
      return {
        ...state,
        loader: false,
        saveFeedbackErrMsg: action.message,
      };

    case CLEAR_STATE:
      return {
        ...state,
        saveFeedbackErrMsg: "",
        saveFeedbackMsg: "",
        // loader: false
      };
    default:
      return state;
  }
};

export default HeaderReducer;
